export enum Rotas {
    DEPARTAMENTO                    = 'api/departamento/',
    ALUNO_TRABALHANDO               = 'api/alunostrabalhando/',
    ALUNO                           = 'api/aluno/',
    ATENDIMENTO                     = 'api/atendimento/',
    ATIVIDADE_ALUNO                 = 'api/atividadesaluno/',
    MATRICULAS                      = 'api/matriculas/',
    AVALIACAO_ALUNO                 = 'api/avaliacaoaluno/',
    AVALIACAO_ATIVIDADE             = 'api/avaliacoes/',
    DIAGNOSTICOS                    = 'api/diagnosticos/',
    ENTIDADE_SOCIAL                 = 'api/entidadessociais/',
    FAMILIARES                      = 'api/familiar/',
    FREQUENCIA_ALUNO                = 'api/frequenciaaluno/',
    PARTICIPANTE_ATENDIMENTO        = 'api/participanteatendimento/',
    PESSOA_FISICA                   = 'api/pessoafisica/',
    REPROVACAO_ALUNO                = 'api/reprovacaoaluno/',
    SITUACAO_VULNERABILIDADE        = 'api/situacoesvulnerabilidade/',
    SOLUCOES                        = 'api/solucoes/',
    UNIFORME_ALUNO                  = 'api/uniformealuno/',
    CARGO                           = 'api/cargos/',
    CURSO_FORMACAO                  = 'api/cursoformacaopf/',
    GRAUS_INSTRUCAO                 = 'api/grausinstrucao/',
    QUESTIONARIO                    = 'api/questionarios/',
    EMPRESAS                        = 'api/empresas/',
    DOADORES                        = 'api/doadores/',
    FUNCIONARIOS                    = 'api/funcionario/',
    FALTAS_FUNCIONARIOS             = 'api/faltasfuncionario/',
    TALENTOS                        = 'api/talentospf/',
    ACOES_COMPETENCIA               = 'api/acoescompentencia/',
    CONDICAO_MORADIA                = 'api/condicaomoradia/',
    USUARIO                         = 'api/usuario/',
    USUARIO_SISTEMA                 = 'api/usuariosistema/',
    PROGRAMAS                       = 'api/programas/',
    PROJETOS                        = 'api/projetos/',
    DOCUMENTO_ATIVIDADE             = 'api/documentosatividade/',
    MATERIAIS_ATIVIDADE             = 'api/materiaisatividade/',
    CADASTRO_RESERVA_ATIVIDADE      = 'api/cadastroreservaatividade/',
    UNIDADE                         = 'api/unidade/',
    ACOES_OFICINAS                  = 'api/acoesoficinas/',
    INSTITUICAO                     = 'api/instituicao/',
    PERFIL_ACESSO                   = 'api/perfilacesso/',
    GRUPO_MODULO                    = 'api/grupomodulo/',
    MODULO                          = 'api/modulo/',
    USUARIO_UNIDADE                 = 'api/usuariounidade/',
    CBO                             = 'api/cbo/',
    OCORRENCIA_ALUNO                = 'api/ocorrenciaaluno/',
    TIPO_OCORRENCIA_ALUNO           = 'api/tipoocorrenciaaluno/',
    TIPOS_CONTRATACOES              = 'api/tiposcontratacoes/',
    DEPENDENTES                     = 'api/dependentes/',
    PRESTACAO_CONTAS                = 'api/prestacaocontas/',
    NIVEIS_TURMAS                   = 'api/niveisturmas/',
    TURMAS                          = 'api/turmas/',
    MATERIAIS                       = 'api/materiais/',
    OFICINA                         = 'api/oficinas/',
    PLANO_CARGO_SALARIO             = 'api/planoscargosalario/',
    FUNCOES                         = 'api/funcoes/',
    PLANOS_CONTAS_CONTABEIS         = 'api/planoscontascontabeis/',
    COTACOES_MATERIAIS              = 'api/cotacoesmateriais/',
    PEDIDOS                         = 'api/pedidos/',
    CONTAS_BANCARIA                 = 'api/contasbancarias/',
    ESTOQUES                        = 'api/estoques/',
    MOVIMENTACOES                   = 'api/movimentacoes/',
    PEDIDOS_MATERIAIS               = 'api/pedidosmateriais/',
    FATURAS                         = 'api/faturas/',
    SALDOS_CONTAS_BANCARIA          = 'api/saldoscontasbancaria/',
    MOVIMENTACOES_MATERIAIS         = 'api/movimentacoesmateriais/',
    ITENS_PEDIDOS_MATERIAIS         = 'api/itenspedidosmateriais/',
    ITENS_MOVIMENTACOES             = 'api/itensmovimentacoes/',
    EXTRATO                         = 'api/extrato/',
    TRIBUTOS                        = 'api/tributos/',
    CONCILIACAO                     = 'api/conciliacao/',
    PROVISAO                        = 'api/provisao/',
    RATEIOS_PROGRAMA_PROJETO        = 'api/rateiospp/',
    EXPORTAR_DADOS_ALUNO            = 'api/exportardadosaluno/',
    PROGRAMA_PROJETO_INSTITUICAO    = 'api/programasprojetos/',
    TIPOS_ATIVIDADES                = 'api/tiposatividades/',
    GESTAO_PESSOAL                  = 'api/relatoriogestaopessoal/',
    SITUACOES_EX_ALUNOS             = 'api/situacoesexalunos/',
    MOTIVOS_DESLIGAMENTOS           = 'api/motivosdesligamentos/',
    TIPOS_PUBLICO_PRIORITARIO       = 'api/tipospublicoprioritario/',
    TIPOS_DOADORES                  = 'api/tiposdoadores/',
    BENEFICIOS_SOCIAIS              = 'api/beneficiossociais/',
    FORNECEDORES                    = 'api/fornecedores/',
    GRUPO_ACOES                     = 'api/grupoacoes/',
    MOVIMENTACOES_CONTABEIS         = 'api/movimentacoescontabeis/',
    ESCOLA                          = 'api/escola/',
    SERIE_ESCOLAR                   = 'api/serieescolar/',
    REGIAO_ADMINISTRATIVA           = 'api/regiaoadministrativa/',
    GRAUS_PARENTESCO                = 'api/grausparentesco/',
    EIXO_ATIVIDADE                  = 'api/eixoatividade/',
    PERIODO_ATIVIDADE               = 'api/periodoatividade/',
    TIPO_CONTRATO                   = 'api/tipocontrato/',
    CONTRATO                        = 'api/contrato/',
    PERCURSO                        = 'api/percurso/',
    EIXO                            = 'api/eixo/',
    META_OBJETIVO                   = 'api/metaObjetivo/',
    MODULO_REUNIOES                 = 'api/moduloreunioes/',
    REUNIOES                        = 'api/reunioes/',
    ACAO_EXECUTADA                  = 'api/acaoExecutada/',
    RIM                             = 'api/rim/',
    CONSULTA_BANCO                  = 'api/consultaBanco/',
    TIPO_CONTEUDO_RIM               = 'api/tipoConteudoRim/',
    CONTEUDO_RIM_ARQUIVO            = 'api/arquivoconteudorim/',
    FERIADO                         = 'api/feriado/',
    OFICINA_TURMAS                  = 'api/oficinaturmas/',
    TIPOS_REUNIOES                  = 'api/tiposreunioes/',
    PUBLICOS_ALVOS                  = 'api/publicosalvos/',
    MATRICULA_SECRETARIA            = 'api/matriculasecretaria/',
    ARQUIVO_EXTRATO                 = 'api/arquivoextrato/',
    LINHA_EXTRATO                   = 'api/linhaextrato/',
    CONJUNTOS_CATEGORIA_CONTABIL    = 'api/conjuntocategoriacontabil/',
    TIPOS_LANCAMENTOS_EXTRATO       = 'api/tiposlancamentosextrato/'

}
